import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className={`text-xl font-bold whitespace-nowrap ${isScrolled ? 'text-foreground-950' : 'text-white'}`}>
              {siteInfo.logo}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (isScrolled ? 'text-foreground-950' : 'text-white') : ''}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
                } ${location.pathname === `/category/${cat.slug}` ? (isScrolled ? 'text-foreground-950' : 'text-white') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/about' ? (isScrolled ? 'text-foreground-950' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center ${isScrolled ? 'text-foreground-950' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2 text-sm text-foreground-700 hover:text-foreground-950">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="py-2 text-sm text-foreground-700 hover:text-foreground-950">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-2 text-sm text-foreground-700 hover:text-foreground-950">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}